<template>
  <!--
    SANEAMENTO DA FASE 2 — contato da Secretaria parametrizado.

    Esta tela trazia, em texto fixo, o endereço de Águas de Lindóia e o e-mail/telefone de
    Vitória da Conquista (`pmvc.ba.gov.br`) — dois municípios que não são o da instalação.

    O sistema não guarda endereço, e-mail ou telefone da Secretaria em nenhuma tabela, e
    inventá-los seria pior do que omiti-los. Os valores passam a vir de
    `parametros_sistema` (`identidade.*`); cada bloco não configurado simplesmente não é
    exibido.
  -->
  <div>
    <h4 class="titulo-component">Contato</h4>

    <div class="container-inscricao">
      <div style="margin-top: 20px">
        <p class="u-mb-20">
          <b>{{ identidade.secretaria }}</b>
          <span v-if="identidade.municipio_uf"><br />{{ identidade.municipio_uf }}</span>
        </p>

        <template v-if="identidade.endereco">
          <b>Endereço:</b>
          <p class="u-mt-10 u-mb-20" v-html="quebrarLinhas(identidade.endereco)"></p>
        </template>

        <template v-if="identidade.email">
          <b>E-mail:</b>
          <p class="u-mt-10 u-mb-20">
            <a :href="`mailto:${identidade.email}`">{{ identidade.email }}</a>
          </p>
        </template>

        <template v-if="identidade.whatsapp">
          <b>Whatsapp</b>

          <p class="u-mt-10 u-mb-20 mobile">
            <a :href="`https://api.whatsapp.com/send?phone=${identidade.whatsapp}`" target="_blank">
              <img src="public/icon/whatsapp.png" />
            </a>
            {{ identidade.whatsapp }}
          </p>

          <p class="u-mt-10 u-mb-20 desktop">
            <a :href="`https://web.whatsapp.com/send?phone=${identidade.whatsapp}`" target="_blank">
              <img src="public/icon/whatsapp.png" />
            </a>
            {{ identidade.whatsapp }}
          </p>
        </template>

        <template v-if="identidade.telefones && identidade.telefones.length">
          <b>Telefones:</b>
          <p class="u-mt-10 u-mb-20">
            <span v-for="(t, i) in identidade.telefones" :key="i">
              {{ t }}<br />
            </span>
          </p>
        </template>

        <!-- Nada configurado ainda: diz isso, em vez de mostrar o contato de outro município. -->
        <el-alert v-if="semContato" type="info" :closable="false"
                  title="Os dados de contato da Secretaria ainda não foram cadastrados no sistema.">
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { identidadeMixin } from '@/shared/identidade'

export default {
  mixins: [identidadeMixin],

  computed: {
    semContato () {
      const i = this.identidade

      return !i.endereco && !i.email && !i.whatsapp && (!i.telefones || !i.telefones.length)
    }
  },

  methods: {
    /** O endereço é um campo livre; a quebra de linha do texto vira <br>. */
    quebrarLinhas (texto) {
      return String(texto)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\n/g, '<br />')
    }
  }
}
</script>
